(function () {
  'use strict';

  var userAgent = navigator.userAgent || '';
  var isMetaInAppBrowser = /Instagram|FBAN|FBAV|FB_IAB|FBIOS/i.test(userAgent);

  if (!isMetaInAppBrowser) return;

  document.documentElement.classList.add('meta-in-app-browser');

  function skipViewTransition(event) {
    var viewTransition = event && event.viewTransition;

    if (viewTransition && typeof viewTransition.skipTransition === 'function') {
      viewTransition.skipTransition();
    }
  }

  // Meta WebViews can expose an incomplete View Transition API and get stuck on
  // the blank transition frame. Always use normal document navigation instead.
  window.addEventListener('pageswap', skipViewTransition);
  window.addEventListener('pagereveal', skipViewTransition);

  function isProductPage() {
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(window.location.pathname);
  }

  function releaseStaleScrollLock() {
    if (!isProductPage()) return;

    var openLockingDialog = document.querySelector('dialog[open][scroll-lock]');
    if (openLockingDialog) return;

    document.documentElement.removeAttribute('scroll-lock');
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
  }

  window.addEventListener('pageshow', releaseStaleScrollLock);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', releaseStaleScrollLock);
  } else {
    releaseStaleScrollLock();
  }
})();
